
  import { defineComponent, ref, reactive, toRefs, provide, watch } from "vue";
  import type { ElForm } from "element-plus";
  import { terms_key } from "@/symbols";
  import useUtils from "@/composables/utils";
  import useUser from "@/composables/user";
  import terms from "@/components/terms.vue";
  import { User } from "@/types/user-type";

  export default defineComponent({
    components: {
      terms,
    },
    setup() {
      // composables
      const { route_handler, show_notification } = useUtils();
      const { sign_up_composables, response } = useUser();
      // form data
      const open_terms = ref<boolean>(false);
      provide(terms_key, open_terms);
      const regexp =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      type FormInstance = InstanceType<typeof ElForm>;
      const form_ref = ref<FormInstance>();
      const form = reactive<User>({
        document: "",
        email: "",
        password: "",
        confirm_password: "",
        accept_terms: false,
      });
      const rules = reactive({
        document: [
          {
            required: true,
            message: "El NIT o el documento es requerido",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "El correo es requerido",
            trigger: "blur",
          },
          {
            validator: (
              rule: unknown,
              value: string,
              callback: (args?: Error) => Error
            ) => {
              !regexp.test(value)
                ? callback(new Error("El correo no es válido"))
                : callback();
            },
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: "La contraseña es requerida",
            trigger: "blur",
          },
        ],
        confirm_password: [
          {
            required: true,
            message: "La confirmación es requerida",
            trigger: "blur",
          },
          {
            validator: (
              rule: unknown,
              value: string,
              callback: (args?: Error) => Error
            ) => {
              value !== form.password
                ? callback(new Error("Las contraseñas no son iguales"))
                : callback();
            },
            trigger: "change",
          },
        ],
        accept_terms: [
          {
            validator: (
              rule: unknown,
              value: string,
              callback: (args?: Error) => Error
            ) => {
              !value
                ? callback(new Error("Debe aceptar la protección de datos"))
                : callback();
            },
            trigger: "change",
          },
        ],
      });
      // methods
      const onSubmit = (form_el: FormInstance | undefined): boolean | void => {
        if (!form_el) return;
        form_el.validate(async (valid) => {
          if (!valid) return false;
          await sign_up_composables(form);
        });
      };
      // watcher
      watch(response, (new_val) => {
        if (new_val.status !== 201) return show_notification(new_val.message);
        route_handler("/");
      });
      return { form_ref, form, ...toRefs(form), rules, onSubmit, open_terms };
    },
  });
